/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { concat, clone, dropLast, isEmpty, isNil, keys, omit, propEq, values, equals } from 'ramda';
import Button from '@components/@core/AnimatedButton';
import CareerCertificationHeader from '@components/CareerCertificationHeader';
import Dropdown from '@components/@core/Dropdown';
import Input from '@components/@core/Input';
import * as ProgramsList from '@components/LibraryProgramsList';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Settings from '@components/@core/Settings';
import TrainingCourses from '~/views/Manage/Reports/TrainingCourses';
import { TrainingTypes, Expirations } from './Config';

class Edit extends Component {
    state = {
        levelInd: 0,
        job: find(propEq('id', this.props.program.job_role_id), this.props.jobs) || {},
        program: this.props.program,
        // programLevels: this.props.program.data.levels || [],
        certificateLink: values(this.props.program.data.attachments)[0] || null,
        attachment: [],
        iconLink: this.props.program.data.thumb_url,
        levelData: [],
        isLevel: false,
        certificatePdf: values(this.props.program.data.levels)[0]?.certificate_pdf?.path || '',
        level: keys(this.props.program.data.levels).length,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { program } = prevState;
        const isLevel = !isNil(program.data.levels) && !isEmpty(program.data.levels);
        const levelData = isLevel ? values(program.data.levels) : [];

        let newLevelData = clone(levelData);
        let card = clone(nextProps.location?.state?.card) || {};
        newLevelData.forEach((item, index) => {
            const duplicate = item.quotas.some((item) => item.id === card.id);
            if (nextProps.location?.state?.level === index + 1 && !duplicate) item.quotas.push(card);
        });
        return { isLevel, levelData: newLevelData };
    }

    handleChangeTitle = (title) => {
        const { program } = this.state;
        const newProgram = { ...program, title };
        this.setState({ program: newProgram });
    };

    handleChangeDescription = (description) => {
        const { program } = this.state;
        const newProgram = { ...program, data: { ...program.data, description } };
        this.setState({ program: newProgram });
    };

    handleSelectTags = (key) => (tag) => {
        const { program } = this.state;
        let newProgram = { ...program };
        switch (key) {
            case 'author':
                newProgram = { ...program, author_id: tag[0] };
                break;
            case 'department':
                newProgram = { ...program, data: { ...program.data, department: tag } };
                break;
            case 'competency':
                newProgram = { ...program, data: { ...program.data, competency: tag } };
                break;
            case 'category':
                newProgram = { ...program, data: { ...program.data, category: tag } };
                break;
            case 'job_title':
                newProgram = { ...program, job_title_id: tag[0] };
                break;
            default:
                break;
        }
        this.setState({ program: newProgram });
    };

    handleChangeLevel = (key, ind) => (e) => {
        const { program, isLevel } = this.state;
        if (!isLevel) return;
        let programLevels = clone(program.data.levels);
        if (key === 'trainings') {
            programLevels[ind][key] = { ...programLevels[ind][key], items: e };
        } else if (key === 'expiration') {
            programLevels[ind].expired_at = e[0];
        } else {
            programLevels[ind][key] = e;
        }
        const newProgram = { ...program, data: { ...program.data, levels: programLevels } };
        this.setState({ program: newProgram });
    };

    handleAddModule = (type, ind) => () => {
        const { program } = this.state;
        let programLevels = clone(program.data.levels);
        let after = [];
        if (type === 'quotas') {
            after = programLevels[ind][type];
        } else if (type === 'habits') {
            after = concat(concat(programLevels[ind][type].day, programLevels[ind][type].week), programLevels[ind][type].month);
        }

        this.props.onModal({
            type: 'Attach Library',
            data: { before: { modules: [], show: [type], selected: [] }, after },
            callBack: {
                onAttach: (e) => {
                    if (type === 'quotas') {
                        programLevels[ind]['quotas'] = concat(programLevels[ind]['quotas'], e.templates);
                    } else if (type === 'habits') {
                        let day = [],
                            week = [],
                            month = [];
                        e.templates.map((item) => {
                            if (item.data.schedule_interval === 'day') {
                                day.push(item);
                            } else if (item.data.schedule_interval === 'week') {
                                week.push(item);
                            } else {
                                month.push(item);
                            }
                        });
                        programLevels[ind]['habits'].day = concat(programLevels[ind]['habits'].day, day);
                        programLevels[ind]['habits'].week = concat(programLevels[ind]['habits'].week, week);
                        programLevels[ind]['habits'].month = concat(programLevels[ind]['habits'].month, month);
                    }
                    const newProgram = { ...program, data: { ...program.data, levels: programLevels } };
                    this.setState({ program: newProgram });
                },
            },
        });
    };

    handleDrop = (type) => (e) => {
        if (type === 'icon') {
            this.setState({ iconLink: e });
        } else {
            this.setState({ attachment: e[0] });
        }
    };

    handleSelectModule = (ind) => (e) => {
        const type = e[0].name;
        const { program } = this.state;
        let programLevels = clone(program.data.levels);
        let after = programLevels[ind]['trainings'].items;

        this.props.onModal({
            type: 'Attach Library',
            data: { before: { modules: [], show: [type], selected: [] }, after },
            callBack: {
                onAttach: (e) => {
                    let templates = clone(e.templates);
                    templates = templates.map((item) => {
                        item.type = dropLast(1, type);
                        return item;
                    });
                    programLevels[ind]['trainings'].items = concat(programLevels[ind]['trainings'].items, templates);
                    const newProgram = {
                        ...program,
                        data: {
                            ...program.data,
                            levels: programLevels,
                        },
                    };
                    this.setState({ program: newProgram });
                },
            },
        });
    };

    handleContentPagination = (e) => {
        this.setState({ levelInd: e - 1 });
    };

    handleAddLevel = () => {
        let { program, level, levelInd } = this.state;
        let _levels = clone(program.data.levels);
        _levels[level + 1] = {
            title: `Level ${Object.values(program.data.levels)?.length + 1}`,
            chronology_lock: false,
            time_lock: false,
            habits: { day: [], week: [], month: [] },
            quotas: [],
            trainings: { items: [] },
        };
        const _program = { ...program, data: { ...program.data, levels: _levels } };
        level = values(_levels).length;
        this.setState({ program: _program, level, levelInd: levelInd + 1 });
    };

    handleLevelDelete = (index) => () => {
        let { program, level } = this.state;
        let _levels = clone(program.data.levels);
        _levels = omit([index], _levels);
        _levels = values(_levels);
        level = _levels.length;
        let levels = {};
        for (let i = 0; i < level; i++) {
            levels[i + 1] = { ..._levels[i] };
        }
        const _program = { ...program, data: { ...program.data, levels } };
        this.setState({ program: _program, level, levelInd: 0 });
    };

    handleDocumentName = (document) => {
        let filename = document?.split('%2F');
        if (filename.length > 1) {
            filename.splice(0, 2);
            return filename;
        } else {
            return document;
        }
    };

    handleSave = (published) => () => {
        const { program, attachment, iconLink, isLevel, certificatePdf } = this.state;
        const programLevels = isLevel ? clone(program.data.levels) : null;
        let levels = {};
        const isImage = typeof iconLink?.name == 'string';
        const isFile = typeof attachment?.name == 'string';

        if (!isNil(programLevels)) {
            keys(programLevels).map((key) => {
                const day = programLevels[key].habits.day.map((item) => item.id);
                const week = programLevels[key].habits.week.map((item) => item.id);
                const month = programLevels[key].habits.month.map((item) => item.id);
                const habits = { day, week, month };
                const quotas = programLevels[key].quotas.map((item) => {
                    return {
                        quota_template_id: item.id,
                        quota_target: item.quota_target || 0,
                        quota_calculation: item.quota_calculation || 0,
                        span_months: item.span_months || 0,
                        quota_direction: item.quota_direction || 0,
                        minimum_months: item.minimum_months || 0,
                    };
                });
                const trainings = programLevels[key].trainings.items.map((item) => {
                    const type = item.card_type_id === 1 ? 'course' : 'track';
                    return { type, item_id: item.id };
                });
                levels[key] = {
                    ...programLevels[key],
                    habits,
                    quotas,
                    trainings: { ...programLevels[key].trainings, items: trainings },
                };
            });
        }
        const newProgram = {
            ...program,
            published,
            data: { ...program.data, levels, attachments: certificatePdf },
        };
        const payload = { type: 'certifications', data: { program: newProgram } };
        this.props.onSave(payload, isImage ? iconLink : null, isFile ? attachment : null);
    };

    handleLabelTitle = (title) => {
        const { program, levelInd } = this.state;
        const _data = {
            ...program,
            data: {
                ...program.data,
                levels: {
                    ...program.data.levels,
                    [Number(levelInd) + 1]: {
                        ...program.data.levels[Number(levelInd) + 1],
                        title: title,
                    },
                },
            },
        };
        this.setState({ program: _data });
    };

    render() {
        const { tags, quotaOptions } = this.props;
        const { authors, departments, competencies, categories } = tags;
        const { levelInd, program, certificateLink, iconLink, levelData } = this.state;
        const disabled = equals(this.props.program, program) || isEmpty(iconLink) || isEmpty(certificateLink);

        const { quotas, trainings } = levelData[levelInd];

        const settings = [
            { name: 'Author', id: [program.author_id], options: authors, select: 'author' },
            {
                name: 'Departments',
                id: program.data.department?.length > 0 ? program.data.department : null,
                options: departments,
                select: 'department',
            },
            {
                name: 'Competencies',
                id: program.data.competency?.length > 0 ? program.data.competency : null,
                options: competencies,
                select: 'competency',
            },
            {
                name: 'Categories',
                id: program.data.category?.length > 0 ? program.data.category : null,
                options: categories,
                select: 'category',
            },
        ];
        const programLevels = Object.values(program.data.levels);

        return (
            <div className="lib-programs-certification">
                <div className="certification-detail">
                    <CareerCertificationHeader program={this.state.program} type="certifications" changeTitle={this.handleChangeTitle} changeDescription={this.handleChangeDescription} editable />
                </div>
                <div className="modules-contents mt-3">
                    <div key={`level-${levelInd + 1}`}>
                        <div className="d-flex">
                            <p className="d-flex-1 dsl-b22 bold">Requirements</p>
                        </div>
                        <ResponsiveTabs
                            className="mb-3"
                            active={`${levelInd}`}
                            data={programLevels?.map((level, index) => ({
                                id: `${index}`,
                                name: level?.title?.length > 15 ? `${level.title?.substring(0, 15)}...` : level?.title || 'NA',
                            }))}
                            onTab={(e) => this.setState({ levelInd: Number(e.id) })}
                        />
                        <div className="d-flex">
                            <Input title="Level Title" value={programLevels[levelInd].title} onChange={this.handleLabelTitle} />
                        </div>
                        <div className="required-field pt-4">
                            <p className="dsl-b18 text-500">Goals</p>
                            <ProgramsList.QuotaList modules={quotas} quotaOptions={quotaOptions} onChange={this.handleChangeLevel('quotas', levelInd + 1)} type="certification" />
                            <div className="d-h-end pt-4">
                                <Button name="Attach Goal" type="low" onClick={this.handleAddModule('quotas', levelInd + 1)} />
                            </div>
                        </div>
                        <div className="required-field">
                            <TrainingCourses data={trainings.items} isEditable onChange={this.handleChangeLevel('trainings', levelInd + 1)} />
                            <div className="d-h-end py-4">
                                <Dropdown
                                    align="right"
                                    width="fit-content"
                                    caret="none"
                                    returnBy="data"
                                    placeholder="Attach Learning"
                                    className="add-training-dropdown"
                                    selectable={false}
                                    data={TrainingTypes}
                                    onChange={this.handleSelectModule(levelInd + 1)}
                                />
                            </div>
                        </div>
                        <div className="required-field py-4">
                            <p className="dsl-b18 text-500">Expiration</p>
                            <Dropdown
                                className="expiration-dropdown"
                                align="right"
                                title="Expires:"
                                data={Expirations}
                                getValue={(e) => e.name}
                                defaultIds={[programLevels[levelInd].expired_at]}
                                value={programLevels[levelInd].expired_at}
                                onChange={this.handleChangeLevel('expiration', levelInd + 1)}
                            />
                        </div>
                    </div>
                </div>
                <div className="mt-3 d-h-end">
                    <Button name="Add Level" type="low" onClick={this.handleAddLevel} />
                </div>
                <Settings values={settings} isEditable expanded handleSelect={this.handleSelectTags} />
                <div className="d-flex flex-column pt-3">
                    <div className="d-h-end mt-2">
                        <>
                            <Button className="btn-save me-3" name="Draft" disabled={disabled && !program.published} type="low" onClick={this.handleSave(0)} />
                            <Button className="btn-save" name="Publish" disabled={disabled && program.published} onClick={this.handleSave(1)} />
                        </>
                    </div>
                </div>
            </div>
        );
    }
}

Edit.propTypes = {
    role: PropTypes.number,
    program: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        data: PropTypes.any,
    }),
    location: PropTypes.object,
    navigate: PropTypes.func,
    onSelect: PropTypes.func,
};

Edit.defaultProps = {
    role: 1,
    program: { id: 0, title: '', data: {} },
    location: {},
    navigate: () => {},
    onSelect: () => {},
};

export default Edit;
